import styled from '@emotion/styled'

const S = {}

S.Dropdown = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  font: inherit;
`

export default S
